
export default {
  name: "NewsCard",
  props: ["imgSrc", "title", "url", "body"]
};
